import { useUserStore } from "~/stores/userstore";
import { useCompanyStore } from "~/stores/companystore";
import { useCompanyAddressStore } from "~/stores/companyaddressstore";
import type {
  WebModelGetAddress,
  WebModelGetCompany,
  WebModelGetCountry,
} from "~/model/api/pLCnextStoreFrontendAPI.schemas";
import { useCountriesStore } from "~/stores/countriesstore";
import { useUserCountryStore } from "~/stores/usercountrystore";

export function useCountryLoader() {
  const userStore = useUserStore();
  const companyAddressStore = useCompanyAddressStore();
  const companyStore = useCompanyStore();
  const countriesStore = useCountriesStore();
  const userCountryStore = useUserCountryStore();

  // reactively update country based on user or company changes
  watch(
    (): [
      WebModelGetCountry | null | undefined,
      WebModelGetCompany | null | undefined,
      WebModelGetAddress | null | undefined,
    ] => [
      userStore.authUser?.country,
      companyStore.userCompany,
      companyAddressStore.legalAddress,
    ],
    async ([authCountry, company, legal]: [
      WebModelGetCountry | null | undefined,
      WebModelGetCompany | null | undefined,
      WebModelGetAddress | null | undefined,
    ]) => {
      // if the user is logged in and has a company use that
      // if the user is logged in and has no company use his selected country
      let iso = null;
      if (company && legal) {
        iso = legal.country;
        console.debug(
          "Using legal address country: " + legal.country + " as user country.",
        );
      } else if (authCountry) {
        iso = authCountry.iso;
        console.debug(
          "Using user country: " + authCountry.iso + " as user country.",
        );
      }
      await userCountryStore.findUserCountryIsoString(iso);
    },
    { immediate: true },
  );

  // reactively load country category whenever country changes or the countries list changes
  watch(
    () => [userCountryStore.userCountryIso, countriesStore.countries],
    async () => {
      await userCountryStore.loadUserCountryFromIsoString(
        userCountryStore.userCountryIso,
        countriesStore.countries,
      );
    },
    { immediate: true },
  );
}
